import { useCallback } from "react";
import { Pressable } from "@-/com.npmjs.react-native";
import { cn } from "@-/com.npmjs.cn";
import { Icon, type IconName } from "@-/dev.improve.haniverse.components.ui.icon";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";

export type MorphemeSelectionOverlayActionButtonProps = {
  actionKey: string;
  disabled?: boolean;
  icon: IconName;
  label: string;
  onPress: (actionKey: string) => void;
};

export function MorphemeSelectionOverlayActionButton({
  actionKey,
  disabled = false,
  icon,
  label,
  onPress,
}: MorphemeSelectionOverlayActionButtonProps) {
  const handlePress = useCallback(() => {
    onPress(actionKey);
  }, [actionKey, onPress]);

  return (
    <Pressable
      accessibilityLabel={label}
      accessibilityRole="button"
      className={cn(
        "h-full flex-1 flex-row items-center justify-center gap-1 px-0.5 active:bg-accent",
        disabled && "opacity-40",
      )}
      disabled={disabled}
      onPress={handlePress}
      testID={`morpheme-selection-action-${actionKey}`}
    >
      <Icon className="shrink-0 text-foreground" name={icon} size={16} />
      <Text className="shrink text-[11px] font-medium text-foreground" numberOfLines={1}>
        {label}
      </Text>
    </Pressable>
  );
}
